import Container from './StudioBlankSlate.container';
import StudioBlankSlate from './StudioBlankSlate';

export default Container(StudioBlankSlate);
